import { jsx as d, jsxs as j } from "react/jsx-runtime";
import * as n from "react";
import { u as S } from "./index-DLcqcWxM.js";
import { c as A } from "./index-UFb2E87s.js";
import { c as N } from "./index-DLeNytVF.js";
import { u as L } from "./index-DYfkNB0n.js";
import { u as z } from "./index-BZPx6jYI.js";
import { u as H } from "./index-CHDs-SiB.js";
import { P as K } from "./index-L6dgm95g.js";
import "react-dom";
import { c as T } from "./index-CM5R_ZZi.js";
import { $ as g } from "./utils-CTvPli9r.js";
import { C as q } from "./check-VaVUBvxu.js";
var U = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], R = U.reduce((e, o) => {
  const t = T(`Primitive.${o}`), i = n.forwardRef((l, r) => {
    const { asChild: f, ...c } = l, p = f ? t : o;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ d(p, { ...c, ref: r });
  });
  return i.displayName = `Primitive.${o}`, { ...e, [o]: i };
}, {}), x = "Checkbox", [X, de] = A(x), [F, G] = X(x), I = n.forwardRef(
  (e, o) => {
    const {
      __scopeCheckbox: t,
      name: i,
      checked: l,
      defaultChecked: r,
      required: f,
      disabled: c,
      value: p = "on",
      onCheckedChange: C,
      form: v,
      ...y
    } = e, [s, w] = n.useState(null), E = S(o, (a) => w(a)), m = n.useRef(!1), k = s ? v || !!s.closest("form") : !0, [h, P] = L({
      prop: l,
      defaultProp: r ?? !1,
      onChange: C,
      caller: x
    }), $ = n.useRef(h);
    return n.useEffect(() => {
      const a = s == null ? void 0 : s.form;
      if (a) {
        const b = () => P($.current);
        return a.addEventListener("reset", b), () => a.removeEventListener("reset", b);
      }
    }, [s, P]), /* @__PURE__ */ j(F, { scope: t, state: h, disabled: c, children: [
      /* @__PURE__ */ d(
        R.button,
        {
          type: "button",
          role: "checkbox",
          "aria-checked": u(h) ? "mixed" : h,
          "aria-required": f,
          "data-state": M(h),
          "data-disabled": c ? "" : void 0,
          disabled: c,
          value: p,
          ...y,
          ref: E,
          onKeyDown: N(e.onKeyDown, (a) => {
            a.key === "Enter" && a.preventDefault();
          }),
          onClick: N(e.onClick, (a) => {
            P((b) => u(b) ? !0 : !b), k && (m.current = a.isPropagationStopped(), m.current || a.stopPropagation());
          })
        }
      ),
      k && /* @__PURE__ */ d(
        D,
        {
          control: s,
          bubbles: !m.current,
          name: i,
          value: p,
          checked: h,
          required: f,
          disabled: c,
          form: v,
          style: { transform: "translateX(-100%)" },
          defaultChecked: u(r) ? !1 : r
        }
      )
    ] });
  }
);
I.displayName = x;
var _ = "CheckboxIndicator", B = n.forwardRef(
  (e, o) => {
    const { __scopeCheckbox: t, forceMount: i, ...l } = e, r = G(_, t);
    return /* @__PURE__ */ d(K, { present: i || u(r.state) || r.state === !0, children: /* @__PURE__ */ d(
      R.span,
      {
        "data-state": M(r.state),
        "data-disabled": r.disabled ? "" : void 0,
        ...l,
        ref: o,
        style: { pointerEvents: "none", ...e.style }
      }
    ) });
  }
);
B.displayName = _;
var J = "CheckboxBubbleInput", D = n.forwardRef(
  ({
    __scopeCheckbox: e,
    control: o,
    checked: t,
    bubbles: i = !0,
    defaultChecked: l,
    ...r
  }, f) => {
    const c = n.useRef(null), p = S(c, f), C = z(t), v = H(o);
    n.useEffect(() => {
      const s = c.current;
      if (!s) return;
      const w = window.HTMLInputElement.prototype, m = Object.getOwnPropertyDescriptor(
        w,
        "checked"
      ).set;
      if (C !== t && m) {
        const k = new Event("click", { bubbles: i });
        s.indeterminate = u(t), m.call(s, u(t) ? !1 : t), s.dispatchEvent(k);
      }
    }, [C, t, i]);
    const y = n.useRef(u(t) ? !1 : t);
    return /* @__PURE__ */ d(
      R.input,
      {
        type: "checkbox",
        "aria-hidden": !0,
        defaultChecked: l ?? y.current,
        ...r,
        tabIndex: -1,
        ref: p,
        style: {
          ...r.style,
          ...v,
          position: "absolute",
          pointerEvents: "none",
          opacity: 0,
          margin: 0
        }
      }
    );
  }
);
D.displayName = J;
function u(e) {
  return e === "indeterminate";
}
function M(e) {
  return u(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
var O = I, Q = B;
const V = n.forwardRef(({ className: e, ...o }, t) => /* @__PURE__ */ d(
  O,
  {
    ref: t,
    className: g(
      "peer h-4 w-4 shrink-0 rounded-sm border border-primary shadow focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground",
      e
    ),
    ...o,
    children: /* @__PURE__ */ d(Q, { className: g("flex items-center justify-center text-current"), children: /* @__PURE__ */ d(q, { className: "size-4" }) })
  }
));
V.displayName = O.displayName;
export {
  V as Checkbox
};
//# sourceMappingURL=checkbox.js.map
